import styles from './NotificationBar.style';

class NotificationBar extends React.Component {
  constructor(props) {
    super(props);
    this.timer = null;
  }

  componentDidMount() {
    const { content, lifespan } = this.props;

    if (content && lifespan) {
      this.beginSelfDestruct();
    }
  }

  componentDidUpdate(prevProps) {
    const { content, lifespan } = this.props;

    if (content && lifespan && prevProps.content !== content) {
      if (this.timer) this.timer = null;
      this.beginSelfDestruct();
    }
  }

  getColor() {
    const { content } = this.props;

    switch (content.status) {
      case 'error':
        return '#ef566e';
      case 'succes':
        return '#2dc590';
      case 'warn':
        return '#f59335';
      default:
        return '#2dc590';
    }
  }

  beginSelfDestruct = () => {
    const { deleteContent, lifespan } = this.props;

    this.timer = setTimeout(deleteContent, lifespan);
  };

  render() {
    const {
      classes,
      content,
      className,
      messageClassName,
      adornment,
      containerClassName,
    } = this.props;

    const transitionClasses = classnames(
      classes.default,
      { [classes.transitionIn]: !!content },
      { [containerClassName]: containerClassName },
    );
    const rootClassNames = classnames(classes.root, { [className]: className });
    const messageClassNames = classnames(classes.message, {
      [messageClassName]: messageClassName,
    });

    return (
      <div className={transitionClasses}>
        {content ? (
          <div
            className={rootClassNames}
            style={{ backgroundColor: this.getColor() }}>
            {adornment}
            <p className={messageClassNames}>{content.message}</p>
          </div>
        ) : null}
      </div>
    );
  }
}

NotificationBar.defaultProps = {
  lifespan: null,
  deleteContent: null,
  adornment: null,
};

NotificationBar.propTypes = {
  content: PropTypes.shape({
    message: PropTypes.node.isRequired,
    status: PropTypes.oneOf(['error', 'warn', 'success']).isRequired,
  }),
  className: PropTypes.string,
  messageClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  classes: PropTypes.object.isRequired,
  lifespan: PropTypes.number,
  deleteContent: PropTypes.func,
  adornment: PropTypes.node,
};

export default withStyles(styles)(NotificationBar);
